require("./additional_components/search");
require("./additional_components/carousel");

$(document).ready(function() {
    setTimeout(function() {
        $(document.body).tooltip({ selector: '[data-toggle="tooltip"]' });
    }, 100);

    $('[href^="#"][href!="#"]').click(function() {
        $(jQuery(this).attr('href')).attr('tabIndex', -1).focus();
    });

    // Set the active class to the external carousel controls
    $('#object-carousel').on('slide.bs.carousel', function (a,b,c,d) {
        $('.external-carousel-control').removeClass('active');
        $('.external-carousel-control[data-slide-to="'+ $(a.relatedTarget).index() +'"]').addClass('active');
    });

    // Smooth scroll to anchor
    $('a[href*="#"]').on('click', function(event) {
        var target = $('#' + this.getAttribute('href').split('#').pop());
        console.log('#' + this.getAttribute('href').split('#').pop(), target);
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top - 30
            }, 200);
        }
    });
});
